// extracted by mini-css-extract-plugin
export default {"logo":"ForgotPassword_logo__To-sp","header":"ForgotPassword_header__bl7nY","submit":"ForgotPassword_submit__Lr0Gk","mb4":"ForgotPassword_mb4__y-bWb"};